import { useCallback } from 'react'
import { useAppHistory } from 'routes/dashboard'
import { useQuery } from './useQuery'

export const useSetQuery = () => {
  const query = useQuery()
  const history = useAppHistory()

  return useCallback(
    (data, append = true, replace = false) => {
      const location = new URLSearchParams(append ? { ...query, ...data } : data).toString()
      if (replace) return history.replace(`?${location}`)
      history.push(`?${location}`)
    },
    [query, history]
  )
}
